<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: user.slug }}"
    :showCloseButton="true"
  >
    <span
      slot="heading"
      class="p-3"
    >
      Add a Category
    </span>
    <span
      slot="description"
      class="p-3"
    >
      Add categories for your menu
    </span>
    <form
      slot="content"
      class="mt-3 p-3"
      v-on:submit.prevent="onSubmit"
    >
      <div v-if="!processing">
        <label>Name</label>
        <div class="form-group">
          <input
            placeholder="E.g Breakfast"
            v-model="name"
            type="text"
            class="form-control"
            v-bind:class="{ 'is-invalid': errors.name }"
            id="name"
            required
          />
          <small
            v-if="errors.name"
            class="text-danger"
          >{{
                        errors.name
                    }}</small>
        </div>
        <label>Description</label>
        <div class="form-group">
          <textarea
            v-model="description"
            class="form-control"
            v-bind:class="{ 'is-invalid': errors.description }"
          ></textarea>
          <small
            v-if="errors.description"
            class="text-danger"
          >{{
                            errors.description
                        }}</small>
        </div>
        <h4 class="mt-3 py-2 d-block styled-border h4 border-style-0 text-center border-position-1 ">
          Time slots
        </h4>

        <div class="form-group">
          <div class="form-check py-3 px-1 border-bottom bg-white">
            <label
              class="container-label"
              for="timerestricted"
            ><span>Only show at certain times</span>
              <input
                v-model="isTimeRestricted"
                type="checkbox"
                id="timerestricted"
                true-value="1"
                false-value="0"
              />
            </label>
          </div>
        </div>
        <p
          class="small text-muted"
          v-if="isTimeRestricted==1"
        >
          If you use this feature, make sure you have selected your timezone in your <router-link
            class="color-2"
            :to="{
                                    name: 'userSettings',
                                }"
          >settings</router-link>.
        </p>
        <div
          class="form-group"
          v-if="isTimeRestricted==1"
        >
          <label for="time_from">From</label>
          <div>
            <vue-timepicker
              v-model="timeFrom"
              id="time_from"
              input-class="form-control"
              format="h:mm a"
            ></vue-timepicker>
          </div>
          <label for="time_to">To</label>
          <div>
            <vue-timepicker
              v-model="timeTo"
              id="time_to"
              input-class="form-control"
              format="h:mm a"
            ></vue-timepicker>
          </div>
        </div>

        <div class="py-2 my-5 border-top border-bottom">
          <div class="d-flex align-items-center justify-content-between">
            <label class="h4 p-0 m-0">Publish</label>

            <toggle-button
              v-model="isPublished"
              :sync="true"
              :color="{checked: user.menu_highlight_color}"
              :height="30"
              class="m-0"
            />
          </div>

        </div>
        <formSubmit v-if="!processing" />
      </div>
      <formLoader
        v-if="processing"
        class="text-center my-5"
        :width="30"
      ></formLoader>
    </form>
  </modal>
</template>

<style scoped></style>

<script>
import accountingMixin from "../../../mixins/accountingMixin";
import formMixin from "../../../mixins/formMixin";
import formLoader from "../../form/FormLoader";
import formSubmit from "../../form/FormSubmit";
import modal from "../../shared/Modal";
import draggable from "vuedraggable";
import moment from "moment-timezone";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import { ToggleButton } from "vue-js-toggle-button";
export default {
  mounted() {
    this.processing = true;
    this.getMenu(this.$route.params.userSlug).then((result) => {
      this.processing = false;
    });
  },
  data() {
    return {
      name: null,
      description: null,
      isTimeRestricted: 0,
      timeFrom: {
        h: "12",
        mm: "00",
        a: "am",
      },
      timeTo: {
        h: "12",
        mm: "00",
        a: "am",
      },
      processing: false,
      isPublished: true,
    };
  },
  methods: {
    onSubmit: function () {
      this.processing = true;
      let timeFrom = moment
        .utc(
          this.timeFrom.h + ":" + this.timeFrom.mm + ":00 " + this.timeFrom.a,
          "h:mm:ss a"
        )
        .format("HH:mm:ss");
      let timeTo = moment
        .utc(
          this.timeTo.h + ":" + this.timeTo.mm + ":00 " + this.timeTo.a,
          "h:mm:ss a"
        )
        .format("HH:mm:ss");
      axios
        .post("/api/" + this.$route.params.userSlug + "/menu/categories", {
          name: this.name,
          description: this.description,
          is_time_restricted: this.isTimeRestricted,
          is_published: this.isPublished,
          time_from: timeFrom,
          time_to: timeTo,
        })
        .then(
          (response) => {
            this.processing = false;
            this.error = null;
            if (response.data.id) {
              this.refreshMenu(this.$route.params.userSlug);
              this.closeModals();
            }
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
  },
  components: {
    draggable,
    moment,
    VueTimepicker,
    formLoader,
    formSubmit,
    modal,
    ToggleButton,
  },
  mixins: [accountingMixin],
};
</script>
